import English from "./dist/en-US.json";
import Italian from "./dist/it-IT.json";
import French from "./dist/fr-FR.json";
import German from "./dist/de-DE.json";
import Spanish from "./dist/es-ES.json";
import Japanese from "./dist/ja-JP.json";
import Korean from "./dist/ko-KR.json";
import Portuguese from "./dist/pt-PT.json";
import Chinese from "./dist/zh-CN.json";
import Taiwanese from "./dist/zh-TW.json";

export const getLanguage = (lang) => {
    switch (lang) {
        case "en-US":
            return English;
        case "it-IT":
            return Italian;
        case "fr-FR":
            return French;
        case "de-DE":
            return German;
        case "es-ES":
            return Spanish;
        case "ja-JP":
            return Japanese;
        case "ko-KR":
            return Korean;
        case "pt-PT":
            return Portuguese;
        case "zh-CN":
            return Chinese;
        case "zh-TW":
            return Taiwanese;
       default:
            return English;
    }
}
